import experiments from '../../common/constants/experiments'

export default {
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. brochure template',
  assets_domains: {
    item_thumbnail: 'thumb-gr.s3.envato.com',
    item_image: 'image-gr.s3.envato.com'
  },
  feeds_categories: [
    '/graphics',
    '/print-templates',
    '/epublishing',
    '/textures',
    '/vectors',
    '/infographics',
    '/add-ons',
    '/isolated-objects',
    '/icons',
    '/presentation-templates',
    '/fonts',
    '/web-elements',
    '/logo-templates',
    '/t-shirts',
    '/game-assets'
  ],
  features: {
    /**
     * @description Enable enrolment in Graphic River File Type filter experiment
     * @author Marek Wojtaszek
     * @expires When we gather data on filter usage
     */
    'filesIncludedFilter:enrolment': false,
    /**
     * @description Enable Graphic River File Type filter
     * @author Marek Wojtaszek
     * @expires When we gather data on filter usage
     */
    filesIncludedFilter: false,
    /**
     * @description Show a spinner between the time the server page loads, and the time the client has finished.  This should be turned on for most A/B tests to avoid flicker/changes on client load.
     * @author Conversion Team
     * @expires Never
     */
    'experiments:loading-cover': false,
    /**
     * @description
     * @author Tanya Fonina
     * @expires
     */
    narrowItemCard: true,
    /**
     * @description Enables new routing strategy
     * @author Pawel Galazka / Traffic team
     * @expires
     */
    'routes:new': true,
    /**
     * @description Is true, we collapse the tags filter for all category pages unless it's a bottom level category (no children)

     * @author Geoff Evason
     * @expires Never
     */
    'collapse-tags-unless-bottom-category': true
  },
  experiments_to_features: {
    [experiments.filesIncludedFilter]: {
      0: { filesIncludedFilter: false },
      1: { filesIncludedFilter: false },
      2: { filesIncludedFilter: true },
      3: { filesIncludedFilter: true }
    }
  }
}
